import { ShieldCheck, FileCheck, ScrollText, Lock } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Validation-ready", sub: "IQ/OQ/PQ support & validation package" },
  { icon: FileCheck, label: "Part 11-style e-signatures", sub: "E-signatures & append-only audit trail" },
  { icon: ScrollText, label: "EU GMP Annex 11", sub: "Computerised systems lifecycle" },
  { icon: Lock, label: "GAMP 5 · ALCOA+", sub: "Lifecycle & data integrity" },
];

/**
 * Compact compliance trust strip for the homepage.
 * Signals to QA / regulatory buyers that the suite (eQMS especially) is
 * built against pharma-grade validation standards.
 */
const TrustBand = () => {
  return (
    <section
      aria-label="Compliance and validation standards"
      className="border-y border-border/60 bg-muted/40"
    >
      <div className="container py-8 md:py-10 max-w-6xl">
        <p className="text-center text-[11px] font-bold tracking-[0.2em] uppercase text-muted-foreground mb-5">
          Pharmalify Spine · aligned with GxP expectations
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((it) => (
            <div
              key={it.label}
              className="flex items-center gap-3 rounded-lg border border-border/60 bg-card px-4 py-3"
            >
              <div className="w-9 h-9 rounded-md bg-accent/10 flex items-center justify-center shrink-0">
                <it.icon className="w-4 h-4 text-accent" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-foreground leading-tight">{it.label}</p>
                <p className="text-[11px] text-muted-foreground leading-tight">{it.sub}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-5 text-center text-xs text-muted-foreground">Aligned with 21 CFR Part 11, EU GMP Annex 11, GAMP 5 and ALCOA+. Formal validation is per customer intended use; DB-enforced access and segregation of duties support controlled operations.</p>
      </div>
    </section>
  );
};

export default TrustBand;
